export default __webpack_public_path__ + "static/030-dfcb2ee7fe575d3c0d9e0f071ae63c83.jpg";